import {cacheWrapper, wait} from "@/components/DownloaderApp/utils";

async function _getTwitchClip(url) {
    let times = 6;

    return new Promise((resolve, reject) => {
        const fetchFn = () => fetch(`/api/download-twitch-clip?url=${url}`).then(response => response.json()).then(data => {
            if (data.downloadUrl) {
                resolve(data.downloadUrl)
            } else {
                reject()
            }
        }).catch(err => {
            if (--times <= 0) {
                return reject(err)
            }
            return wait(500).then(() => fetchFn())
        })

        return fetchFn()
    });
}

async function _getTwitchVod(id) {
    if(!window.sendMessage) throw new Error('a')
    return window.sendMessage?.('get-twitch-vod-details', id)
}

export const getTwitchVod = cacheWrapper(_getTwitchVod)
export const getTwitchClip = cacheWrapper(_getTwitchClip)